
window.jQuery = window.$ = require('jquery');

require('bootstrap');

require('./inc-scroll');
require('./inc-fontsize');
require('./inc-page-etablissement');
require('./inc-trouver-etablissement');
require('./inc-header-search');

$(function() {

    $('.univi-upload .forminator-file-upload').each(function(indx, elem){


        if( $(elem).find('.btn-upload-input-clear').length==0 ){
            $(elem).prepend('<div class="btn-upload-input-clear">Annuler</div>');
        }

        if( $(elem).find('.btn-upload-input-title').length==0 ){
            $(elem).prepend('<div class="btn-upload-input-title">Choisir un fichier</div>');
        }

        var btnTitle = $(".btn-upload-input-title").html();
        var btnTitleHtml = $.parseHTML(btnTitle);

        $(elem).find("input:file").on('change', function (){
           console.log("im clicked" + this.files.length);
           if( this.files && this.files.length >= 1 ) {
              var file = this.files[0];
                 var reader = new FileReader();
                 // Set preview image into the popover data-content
                 reader.onload = function (e) {
                    $(elem).addClass('file-choosed')
                    $(elem).find(".btn-upload-input-title").text(file.name);
                 }
                 reader.readAsDataURL(file);
           }else {
                $(elem).removeClass('file-choosed');
                $(elem).find(".btn-upload-input-title").html(btnTitle);
           }
             
         }); 

         $(elem).on('click', '.btn-upload-input-clear', function(e){
            e.preventDefault();
            $(elem).find("input:file").val('').trigger('change'); 
            $(elem).removeClass('file-choosed');
            $(elem).find(".btn-upload-input-title").html(btnTitle);
         });


    });



    $('.forminator-button').each(function(index, elem){

      if( !$(elem).find('.inner').length ){
         $(elem).wrapInner( "<div class='inner'></div>");
      }

    });

    $('.footer-social a.telephone').attr('href', $('.header-quick li:eq(0) a').attr('href'));


    $('.site-header-menu-toggle').click(function(e){
      e.preventDefault();
      $(this).toggleClass('open');
      $('.site-header-content').toggleClass('open');
    });
      
 });
 